import React, { Component }  from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import GridList from '@material-ui/core/GridList';
import Typography from '@material-ui/core/Typography';
import CarLogo from './CarLogo';
import {API} from 'aws-amplify';
import { Link } from 'react-router-dom';

import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import ReactGA from 'react-ga';
import Footer from './Footer';


const styles = theme => ({
  flex: {
    flex: 1,
  },
  appBar: {
    height: '45px',
  },
  featureImage: {
    maxWidth: '60%',
    alignSelf: 'center'
  },
  detailHeader: {
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    //paddingLeft: '10px',
    //paddingTop: '5px',
    //height: '50px',
  },
  contrastText: {
    color: theme.palette.primary.contrastText,
  },
  button: {
    margin: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
  gridList: {
    width: '100%',
    height: 'auto',
  },
  gridListTitleBar: {
    margin: 10,
  },
  icon: {
    color: 'white',
    margin: 10,
  },
});

class CarMakes extends Component {
  state = {
    makes: []
  };

  fetchCarMakes = async (zip) => {
    API.get('leasy','/get-car-makes')
        .then(data => {
          console.log(data);
          this.setState({
              makes: data
          });
          return data;
        })
        .catch (err => console.log(err))
  }

  componentWillMount() {
      this.fetchCarMakes();

      // Google Analytics
      ReactGA.initialize('UA-107081605-2');
      ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    const { classes } = this.props;
    const { makes } = this.state;

    return (
      (makes.length > 0) ?
      <div>


        <Paper className={classes.detailHeader}>
          <IconButton className={classes.contrastText} aria-label="Menu">
            <NavigateNextIcon />
          </IconButton>
          <Typography className={classes.contrastText}  variant="subheading" color="inherit">
            DEALS BY MAKE
          </Typography>
        </Paper>

          <Grid container alignItems="stretch" justify="center" spacing={0}>

            <GridList cellHeight={180} className={classes.gridList}>
              { makes && makes.map((data, i) =>

                  <GridListTile component={Link} to={'/makes/' + data.id} key={data.id}>

                    <img src={data.featureImage} alt={data.id}/>

                    <GridListTileBar

                      titlePosition="top"
                      title={data.displayName}
                      actionIcon={
                        <IconButton className={classes.icon}>
                          <CarLogo brand={data.id}/>
                        </IconButton>
                      }
                      actionPosition="left"
                    />

                  </GridListTile>
              ) }

              <GridListTile key='999'>

                <img src='' />

                <GridListTileBar

                  titlePosition="top"
                  title="More coming soon"
                  actionPosition="left"
                />

              </GridListTile>
            </GridList>
          </Grid>
          <Footer/>
      </div>
      : <CircularProgress className={classes.progress} />
    );
  }

}

CarMakes.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CarMakes);



// WEBPACK FOOTER //
// ./src/components/CarMakes.jsx